import { IFitmentOption } from "interfaces/session/IVehicle";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";

function encodeIfNeeded(str: string) {
  if (!/%[0-9A-Fa-f]{2}/.test(str)) {
    return encodeURIComponent(str);
  }
  return str;
}

export function getFitmentOptionQS(fitmentOptions: IFitmentOption[] = [], includeTiresAndWheels = false) {
  const fitmentQS = fitmentOptions.reduce((prev, curr, idx) => {
    if (!curr.optionValue) return prev;
    const optionStr = `fo.name=${curr.optionName}&fo.value=${encodeIfNeeded(curr.optionValue)}`;
    return prev.concat(idx === fitmentOptions.length - 1 ? optionStr : `${optionStr}&`);
  }, "");

  const extraParamsQS = includeTiresAndWheels
    ? Object.entries(getCustomSizeQuery())
      .flatMap(([key, values]) => values?.map((val: any) => `${key}=${encodeIfNeeded(val)}`) ?? [])
      .join("&")
    : "";

  return [fitmentQS, extraParamsQS].filter(Boolean).join("&");
}
